import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import type { UserInfo } from 'bundles/teams-v2/common/types';

const SERIALIZED_PROPS: Array<keyof PaymentFormStore$DehydratedState> = ['userInfo'];

type PaymentFormStore$DehydratedState = {
  userInfo: UserInfo;
};

class TeamsUserSignupStore extends BaseStore {
  declare userInfo: UserInfo;

  declare registrationErrorCode: string;

  declare emitChange: () => void;

  static storeName = 'TeamsUserSignupStore';

  static handlers = {
    UPDATE_USER_INFO: 'onUpdateUserInfo',
    UPDATE_REGISTRATION_ERROR: 'onUpdateRegistrationErrorCode',
  };

  onUpdateUserInfo(fields: UserInfo) {
    this.userInfo = Object.assign({}, this.userInfo, fields);
    this.emitChange();
  }

  onUpdateRegistrationErrorCode(code: string) {
    this.registrationErrorCode = code;
    this.emitChange();
  }

  dehydrate(): PaymentFormStore$DehydratedState {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: PaymentFormStore$DehydratedState) {
    Object.assign(this, _.pick(state, ...SERIALIZED_PROPS));
  }

  initialize() {
    this.userInfo = {};
  }

  getUserInfo(): UserInfo {
    return this.userInfo;
  }

  getRegistrationErrorCode(): string {
    return this.registrationErrorCode;
  }
}

export default TeamsUserSignupStore;
